import React from 'react';
import { getImageAssetUrl } from '../../../utils/assetUtils';
import { ArrowLink } from './ArrowLink';
import { ProductPageDialogContent } from './ProductPageDialogContent';

interface ProductPageDialogSuccessProps {
  closeDialogText?: string;
  redirectionText?: string;
  redirectionUrl?: string;
  handleClose: () => void;
}

export const ProductPageDialogSuccess: React.FC<ProductPageDialogSuccessProps> = ({
  closeDialogText,
  redirectionText,
  redirectionUrl,
  handleClose,
}) => {
  return (
    <ProductPageDialogContent
      showIcon
      iconProps={{
        src: getImageAssetUrl('icon_success_tick.webp'),
        alt: 'success',
        style: { width: 124, height: 124 },
      }}
      title="Success!"
      subtitle="We sent a text message with a link to download Brandclub and access your rewards."
    >
      {closeDialogText && <ArrowLink text={closeDialogText} onTextClick={handleClose} />}
      {redirectionText && redirectionUrl && (
        <ArrowLink
          text={redirectionText}
          url={redirectionUrl}
          onTextClick={() => window.open(redirectionUrl, '_blank')}
        />
      )}
    </ProductPageDialogContent>
  );
};
